import type { Steps } from '../../workflow/schemaTypes';
import { clsx } from 'clsx';
import s from './TaskGrid.module.css';
import type { ReactNode } from 'react';
import { useIsMobile } from '@repo/lib/hooks/useMediaQuery';
import { Flex } from '@repo/ui/Flex';

export const TaskGrid = ({
  step,
  children,
}: {
  step?: Steps;
  children: ReactNode;
}) => {
  const isMobile = useIsMobile();
  if (step && step in s) {
    return (
      <Flex
        className={clsx({
          [s.base]: true,
          [s[step]]: true,
          [s.mobile]: isMobile,
        })}
      >
        {children}
      </Flex>
    );
  }

  return children;
};
